import styled from 'styled-components';

const Product = styled.div`
    height: ${props => (props.size ? props.theme.image[props.size] : props.height)};
    width: ${props => (props.size ? props.theme.image[props.size] : props.width)};
    max-height: 100%;
    max-width: 100%;
    border-radius: ${props => (props.round ? '50%' : 0)};
    background: url(${props => props.src});
    background-repeat: no-repeat;
    background-size: ${props => (props.cover ? 'cover' : 'contain')};
`;

const Image = styled.img`
    width: 100%;
    max-height: ${props => props.theme.image[props.size]};
    max-width: ${props => props.theme.image[props.size]};
    fill: ${props => (props.color ? props.theme.color[props.color] : 'inherit')};
    border-radius: ${props => (props.round ? '50%' : 0)};
    border: ${({ theme, border }) => (border ? `1px solid ${theme.color[border]}` : 'none')};
    margin: ${({ margin }) => margin || 'none'};
`;

Image.Product = Product;
export { Image };



// WEBPACK FOOTER //
// ./src/sc-ui/Image.jsx